import React from 'react';
import PropTypes from 'prop-types';

import PhotoSelectionOverlay from './PhotoSelectionOverlay';
import withModal from '../../../../../../../../../../../components/global/modal/withModal';

export const DIGITAL_BUNDLE_PHOTO_SELECTION_MODAL =
  'modal/DIGITAL_BUNDLE_PHOTO_SELECTION_MODAL';

const propTypes = { onRequestClose: PropTypes.func };

const PhotoSelectionOverlayModal = ({ onRequestClose, ...props }) => {
  return <PhotoSelectionOverlay onClose={onRequestClose} {...props} />;
};

PhotoSelectionOverlayModal.propTypes = propTypes;

export default withModal(PhotoSelectionOverlayModal, {
  name: DIGITAL_BUNDLE_PHOTO_SELECTION_MODAL,
  dismissible: false,
  size: 'sm',
  type: 'full',
  hideHeader: true,
  shouldCloseOnOverlayClick: false,
  className: 'digital-bundle-photo-selection-modal modal-floating-panel',
});
